import styles from "./PopularTopics.module.scss";
import { useEffect, useState } from "react";
import { isNullOrEmpty } from "../../../utils/isNullOrEmpty";
import { getPopularTopics } from "../../../utils/getConstants";
import { useNavigate } from "react-router-dom";
import useAppModernisation from "../../../hooks/useAppModernisation";
import classNames from "classnames";

const PopularTopics = ({ glObj }) => {
  const navigate = useNavigate();
  const [topics, setTopics] = useState(null);
  const { isMobileView } = useAppModernisation();

  useEffect(() => {
    if (isNullOrEmpty(topics)) {
      setTopics(getPopularTopics(glObj?.glPage));
    }
  }, [glObj, topics]);

  return (
    !isNullOrEmpty(topics) && (
      <div className={styles.popularTopics}>
        <div className={styles.popularTopicTitle}>Have you seen these topics?</div>
        <div className={styles.popularTopicsContainer}>
          {topics?.map((item, index) => (
            <div
              className={classNames(styles.popularTopic, isMobileView ? "size-12" : "size-14")}
              onClick={() => {
                navigate(item.link);
              }}
              key={`topic-title-${index}`}
            >
              {item.title}
            </div>
          ))}
        </div>
      </div>
    )
  );
};

export default PopularTopics;
